module.exports = __webpack_public_path__ + "static/media/img_6.574328d9.png";